import React from 'react';
import Typography from '@mui/material/Typography';

interface ListTotalProps {
  total: number;
}

function Label({ total }: ListTotalProps) {
  return (
    <div>
      <Typography className="text-rf-black text-sm">件数：{total}件</Typography>
    </div>
  );
}

export default Label;
